(function(){

    let productList = document.querySelector('product-list');
    const pagination = document.querySelector('.pagination');
    if(productList && pagination) {
        pagination.style.display = 'none';

        new InfiniteScroll( productList, {
            path: '.pagination__link-next',
            append: 'product-card',
            history: false,
            scrollThreshold: 700,
        });
    }
    

})();